export const classes = {
  logo: 'max-h-12 w-auto max-w-[150px] object-contain',
  defaultLogo: 'text-[#ff4e02] dark:text-white',
};
